export const MODAL_NAMES = {
  DETALIZATION_REPORT: 'DETALIZATION_REPORT',
  REGULAR_DETALIZATION_REPORT: 'REGULAR_DETALIZATION_REPORT',
  EMAIL: 'EMAIL',
};
